// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"e13df962","80":"ca6aeab1","679":"c31f6ef2","701":"7bbf04b7"}[chunkId] + ".chunk.js";
};